import type { PurchaseOrderDetail } from '../../../services/purchaseOrders';

export interface PoOutcome {
    held: boolean;
    message: string;
}

export interface PoCreateExpectation {
    chargeLineItemIds: string[];
    vendorId: string;
    poNumber?: string;
}

function sameLineItemIds(actual: PurchaseOrderDetail['lines'], expected: string[]): boolean {
    const actualIds = new Set(actual.map((line) => line.chargeLineItemId));
    return actualIds.size === expected.length && expected.every((id) => actualIds.has(id));
}

// A 201 is not proof either that the record matches what was requested.
export function checkPoCreateOutcome(
    created: PurchaseOrderDetail,
    expectation: PoCreateExpectation
): PoOutcome {
    if (created.vendor.id !== expectation.vendorId) {
        return {
            held: false,
            message: `Recorded, but the vendor is "${created.vendor.name}" rather than the one selected. Refresh and check.`
        };
    }
    if (!sameLineItemIds(created.lines, expectation.chargeLineItemIds)) {
        return {
            held: false,
            message:
                'Recorded, but the line items on the purchase order do not match the selection. Refresh and check.'
        };
    }
    if (expectation.poNumber && created.poNumber !== expectation.poNumber) {
        return {
            held: false,
            message: `Recorded, but the PO number is "${created.poNumber}" rather than "${expectation.poNumber}". Refresh and check.`
        };
    }
    return { held: true, message: `Purchase order ${created.poNumber} recorded` };
}
